import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { buildContextualToolboxComponentsMap } from "../../blocks/componentMaps";

import styles from "./index.module.scss";

export const UtilityPageBody = (
    props: Immutable<{ page: templates.UtilityPageTemplate["page"] }>,
): React.JSX.Element => {
    const components = buildContextualToolboxComponentsMap({
        pageSlug: props.page.slug,
    });
    return (
        <section className={styles.utilityContent}>
            {props.page.body ? (
                <StreamField
                    tagName={React.Fragment}
                    value={props.page.body.value}
                    components={components}
                />
            ) : null}
        </section>
    );
};
